import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { FeedbackSessionRecordViewComponent } from './feedback-session-record-view.component';

export const ngxFeedbackSessionRecordViewModule = angular.module('ngxFeedbackSessionRecordViewModule', [])
	.directive('ngxFeedbackSessionRecordView', downgradeComponent({ component: FeedbackSessionRecordViewComponent }))
	.name;
